module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-forward-search tollbar__search",
    staticStyle: {
      "flex-grow": "3"
    },
    attrs: {
      "id": "page__forwarding__toolbar"
    }
  }, [_vm._m(0), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "rounded": "",
      "danger-light": "",
      "disabled": !_vm.hasFilter
    },
    on: {
      "click": _vm.onReset
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'gear'],
      "rounded": "",
      "primary-light": "",
      "disabled": !_vm.hasFilter
    },
    on: {
      "click": _vm.toggleFilter
    }
  }), _vm._v(" "), (_vm.visibility) ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideFilter),
      expression: "hideFilter"
    }],
    staticClass: "dropdown md-elevation-2"
  }, [_c('div', {
    staticClass: "search-md-menu-container"
  }, [_c('div', {
    staticClass: "filter-container md-layout"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "center-layout md-layout-item with-pr center-layout md-size-80"
  }, [_c('z-date', {
    attrs: {
      "no-margin": "",
      "return-string": false,
      "format": "DD.MM.YYYY",
      "type": "date",
      "placeholder": "Дата от"
    },
    model: {
      value: (_vm.filter.date_from),
      callback: function($$v) {
        _vm.$set(_vm.filter, "date_from", $$v)
      },
      expression: "filter.date_from"
    }
  })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "center-layout with-pr center-layout md-size-80 md-layout-item"
  }, [_c('z-date', {
    attrs: {
      "no-margin": "",
      "return-string": false,
      "format": "DD.MM.YYYY",
      "type": "date",
      "placeholder": "Дата до"
    },
    model: {
      value: (_vm.filter.date_to),
      callback: function($$v) {
        _vm.$set(_vm.filter, "date_to", $$v)
      },
      expression: "filter.date_to"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "center-layout with-pr md-size-80 md-layout-item"
  }, [_c('z-select', {
    model: {
      value: (_vm.filter.user_id),
      callback: function($$v) {
        _vm.$set(_vm.filter, "user_id", $$v)
      },
      expression: "filter.user_id"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(" Любой ")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('option', {
      key: ('user-' + user.id),
      domProps: {
        "value": user.id
      }
    }, [_vm._v(" " + _vm._s(user.label) + " ")])
  })], 2)], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-size-80 center-layout with-pr"
  }, [_c('z-select', {
    model: {
      value: (_vm.filter.completed),
      callback: function($$v) {
        _vm.$set(_vm.filter, "completed", $$v)
      },
      expression: "filter.completed"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(" Любой ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" Забранные или выданные грузы ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v(" И забранные и выданные грузы ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v(" Только забранные грузы ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v(" Только выданные грузы ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v(" Забранные или выданные грузы без маршрутного листа ")])])], 1), _vm._v(" "), (parseInt(_vm.filter.completed) !== 5) ? _c('div', {
    staticClass: "center-layout md-size-20 md-layout-item"
  }, [_c('label', [_vm._v(" Статус маршрутного листа ")])]) : _vm._e(), _vm._v(" "), (parseInt(_vm.filter.completed) !== 5) ? _c('div', {
    staticClass: "center-layout with-pr md-layout-item md-size-80"
  }, [_c('z-select', {
    model: {
      value: (_vm.filter.route_list_status_id),
      callback: function($$v) {
        _vm.$set(_vm.filter, "route_list_status_id", $$v)
      },
      expression: "filter.route_list_status_id"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(" Любой ")]), _vm._v(" "), _vm._l((_vm.statuses), function(status) {
    return _c('option', {
      key: ('status-' + status.id),
      domProps: {
        "value": status.id
      }
    }, [_vm._v(" " + _vm._s(status.label) + " ")])
  })], 2)], 1) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "center-layout with-pr md-size-80 md-layout-item"
  }, [_c('ZInputAutocomplete', {
    attrs: {
      "label": "Город экспедирования (введите город)",
      "placeholder": "Любой",
      "display-property": "label",
      "property": "id",
      "id": "report_filter_city_id",
      "name": "report_filter_city_id",
      "default": _vm.filter.city_label,
      "callback": _vm.getCities
    },
    on: {
      "clear": _vm.clearCity,
      "select": _vm.selectCity
    },
    model: {
      value: (_vm.filter.city_id),
      callback: function($$v) {
        _vm.$set(_vm.filter, "city_id", $$v)
      },
      expression: "filter.city_id"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "center-layout with-pr md-size-80 md-layout-item"
  }, [_c('z-select', {
    model: {
      value: (_vm.filter.nds),
      callback: function($$v) {
        _vm.$set(_vm.filter, "nds", $$v)
      },
      expression: "filter.nds"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(" Любое ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v(" с НДС ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v(" без НДС ")])])], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "center-layout with-pr md-size-80 md-layout-item"
  }, [_c('z-select', {
    model: {
      value: (_vm.filter.executor_id),
      callback: function($$v) {
        _vm.$set(_vm.filter, "executor_id", $$v)
      },
      expression: "filter.executor_id"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(" Любой ")]), _vm._v(" "), _vm._l((_vm.companies), function(company) {
    return _c('option', {
      key: ("filter-executor-" + (company.id)),
      domProps: {
        "value": company.id
      }
    }, [_vm._v(_vm._s(((company.name) + " (НДС " + (company.nds_value) + "%)")))])
  })], 2)], 1), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "center-layout with-pr md-size-80 md-layout-item"
  }, [_c('ZInputMultyValue', {
    attrs: {
      "id": "rl-ids",
      "name": "rl-ids",
      "value-type": "number",
      "placeholder": "№ маршрутного листа"
    },
    model: {
      value: (_vm.filter.ids),
      callback: function($$v) {
        _vm.$set(_vm.filter, "ids", $$v)
      },
      expression: "filter.ids"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "center-layout md-size-100 md-layout-item"
  }, [_vm._v(" Внимание! При указании маршрутных листов остальные фильтры будут игнорироваться! ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-button-container md-alignment-bottom-right md-size-100 md-layout-item"
  }, [_c('z-button', {
    attrs: {
      "fit-content": "",
      "no-margin": ""
    },
    on: {
      "click": _vm.doFilter
    }
  }, [_vm._v(" Применить ")])], 1)])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v(" Для печати отчёта укажите параметры фильтрации ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-layout md-layout-item md-size-20"
  }, [_c('label', [_vm._v(" Дата от ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-layout md-size-20 md-layout-item"
  }, [_c('label', [_vm._v(" Дата до ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-layout md-size-20 md-layout-item"
  }, [_c('label', [_vm._v(" Экспедитор ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-layout md-size-20 md-layout-item"
  }, [_c('label', [_vm._v(" Статус экспедирования ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-layout md-size-20 md-layout-item"
  }, [_c('label', [_vm._v(" Город экспедирования ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-layout md-size-20 md-layout-item"
  }, [_c('label', [_vm._v(" НДС ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-layout md-size-20 md-layout-item"
  }, [_c('label', [_vm._v(" Исполнитель ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-layout md-size-20 md-layout-item"
  }, [_c('label', [_vm._v(" Маршрутные листы ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35808374","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/toolbars/ForwardingToolbar.vue
// module id = 1108
// module chunks = 0